<template>
 <ion-page>
		<spot-header :title="pageTitle + ' ' + (!tablesData || !tablesData.currentProject ? '' : tablesData.currentProject.name)" :canGoHome="false && !isPrinting" :canGoBack="false && !isPrinting" @pressedGoHome="$router.push('/home')" @pressedGoBack="exitOrder"></spot-header>

		<ion-content :fullscreen="true"> <!--v-if="isActive"-->
			<ion-progress-bar type="indeterminate" v-if="!isActive"></ion-progress-bar>
			<div id="actionArea" v-else>
				<web-socket-reader crReplacedChar="|" @readedBarcode="onReadedBarcode" @readedTag="onReadedTag" @readerError="onReaderError"></web-socket-reader>
				<ion-label color="tertiary" v-if="isPrinting">{{isPrintingText}}</ion-label>
				<div class="flex-row-center-container">
					<spot-button
						fill="outline"
						size="small"
						color="danger"
						:enabled="true && !isPrinting"
						:expand="null"
						:text="suspendText"
						@clicked="exitOrder()">
					</spot-button>
					<spot-button
						fill="outline"
						size="small"
						color="success"
						:enabled="true && !isPrinting"
						:expand="null"
						:text="closeText"
						@clicked="closeOrder()">
					</spot-button>
				</div>
				<ion-item>
					<spot-input
						:ref="fields[field.search].name"
						:label="fields[field.search].text"
						:allignLabel="fields[field.search].allignLabel"
						:required="fields[field.search].required"
						:placeholder="fields[field.search].placeholder"
						:enabled="true"
						:value="fields[field.search].value"
						:type="fields[field.search].inputType"
						:clearInput="true"
						@textChanged="changedSearch">
					</spot-input>
					<!--
					<ion-button size="default" slot="end" disabled="true" @click="createNewPick">
						<ion-icon :icon="duplicate" slot="start" size="default"></ion-icon>
						{{ newItemText }}
					</ion-button>
					-->
				</ion-item>
				<ion-progress-bar type="indeterminate" v-if="!tablesData.picks"></ion-progress-bar> <!-- v-if="!tablesData.projectRows" -->
				<EasyDataTable
					:headers="headers"
					:items="tablesData.picks"
					:sort-by="sortBy"
					:sort-type="sortType"
					:search-field="searchFields"
					:search-value="fields[field.search].value"
					:empty-message="noItemsText"
					:body-row-class-name="bodyRowClassNameFunction"
					@click-row="createNewProjectRow($event)"
					multi-sort> <!-- :items="tablesData.projectRows" :body-item-class-name="bodyItemClassNameFunction" show-index alternating -->
					<template #item-actions="pick">
						<!--
						<ion-button disabled=false fill="outline" shape="round" size="small" slot="icon-only" @click="showExistingPick(pick)">
							<ion-icon :icon="reader" slot="end" size="small"></ion-icon>
						</ion-button>
						<ion-button :color="pick.quantity_detected == pick.quantity ? 'success' : (pick.quantity_detected == 0 ? 'danger' : (pick.quantity_detected < pick.quantity ? 'warning' : 'tertiary'))" disabled=false fill="outline" shape="round" size="small" slot="icon-only" @click="editExistingPick(pick)">
							<ion-icon :icon="brush" slot="end" size="small"></ion-icon>
						</ion-button>
						-->
						<ion-button :disabled="pick.project_rows.length == 0" color="dark" fill="outline" shape="round" size="small" slot="icon-only" @click="openAlert(pick)"> <!-- @click="deleteProjectRowsInPick(pick)" @click="deleteExistingPick(pick)" -->
							<ion-icon :icon="trash" slot="end" size="small"></ion-icon>
						</ion-button>
					</template>
					<!--
					<template #item-actions="projectRow">
						<ion-button disabled=false fill="outline" shape="round" size="small" slot="icon-only" @click="showExistingProjectRow(projectRow)">
							<ion-icon :icon="reader" slot="end" size="small"></ion-icon>
						</ion-button>
						<ion-button :color="pick.quantity_detected == pick.quantity ? 'success' : (pick.quantity_detected == 0 ? 'danger' : (pick.quantity_detected < pick.quantity ? 'warning' : 'tertiary'))" disabled=false fill="outline" shape="round" size="small" slot="icon-only" @click="editExistingProjectRow(projectRow)">
							<ion-icon :icon="brush" slot="end" size="small"></ion-icon>
						</ion-button>
						<ion-button disabled=true fill="outline" shape="round" size="small" slot="icon-only" @click="deleteExistingProjectRow(projectRow)">
							<ion-icon :icon="trash" slot="end" size="small"></ion-icon>
						</ion-button>
					</template>
					-->
					<template #expand="item">
						{{item.quantity}} {{item.item.measure_unit.name}} | {{item.item.location.name}} | Note {{(!item.notes)? '-': item.notes}}
					</template>
				</EasyDataTable>
				<ion-modal class="modal-settings" ref="modal" backdrop-dismiss="false" :is-open="isOpenModal" @didDismiss="modalDismissed">
					<ion-content>
						<ion-toolbar>
							<ion-title> {{ modalTitle }}</ion-title>
						</ion-toolbar>
						<div v-for="field in visibleItemContents" :key="field.id">
							<spot-input
								v-if="(field.inputType == 'text' || field.inputType == 'number')"
								:ref="field.name"
								:label="field.text"
								:allignLabel="field.allignLabel"
								:required="field.required"
								:placeholder="getPlaceHolder(field)"
								:enabled="field.enabled && !modalReadOnly"
								:validationState="field.validationState"
								:furtherInfo="field.furtherInfo"
								:value="field.value"
								:type="field.inputType"
								@textChanged="changedTextField(field.id, $event)">
							</spot-input>
							<ion-textarea
								v-if="field.inputType == 'area'"
								:ref="field.name"
								:placeholder="getPlaceHolder(field)"
								:required="field.required"
								:disabled="!field.enabled || modalReadOnly"
								:auto-grow="true"
								:value="field.value">
							</ion-textarea>
							<spot-checkbox
								v-if="field.inputType == 'check'"
								:ref="field.name"
								:label="field.text"
								:allignLabel="field.allignLabel"
								:required="field.required"
								:enabled="field.enabled && !modalReadOnly"
								:validationState="field.validationState"
								:value="field.value"
								@checkboxChanged="changedCheckboxField(field.id, $event)"
								@focus="$event.target.select()">
							</spot-checkbox>
							<spot-select
								v-if="field.inputType == 'select'"
								:ref="field.name"
								:label="field.text"
								:allignLabel="field.allignLabel"
								:required="field.required"
								:placeholder="getPlaceHolder(field)"
								:enabled="field.enabled && !modalReadOnly"
								:enabledExtraButtons="field.enabledExtraButtons && !modalReadOnly"
								:validationState="field.validationState"
								:furtherInfo="field.furtherInfo"
								:value="field.value"
								:options="getOptions(field.id)"
								:optionField="field.refField"
								:canAddItem="field.canAddItem"
								:canRefreshList="field.canRefresh"
								:canUnlock="field.canUnlock"
								:selectedLabel="selectedText"
								:deselectLabel="deselectText"
								:selectLabel="selectText"
								@selected="assignedSelectField(field.id, $event)"
								@unselected="resetSelectField(field.id)"
								@addItem="addPackage">
							</spot-select>
							<spot-date
								v-if="field.inputType == 'datetime'"
								:ref="field.name"
								:label="field.text"
								:allignLabel="field.allignLabel"
								:required="field.required"
								:enabled="field.enabled && !modalReadOnly"
								:validationState="field.validationState"
								:value="field.value"
								color="primary"
								:doneText="confirmText"
								:cancelText="undoText"
								@dateChanged="changedDateField(field.id, $event)">
							</spot-date>
						</div>
						<div class="flex-row-center-container">
							<spot-button
								fill="outline"
								size="large"
								color="primary"
								:enabled="true"
								:expand="null"
								:text="undoText"
								@clicked="closeModal(false)">
							</spot-button>
							<spot-button
								fill="outline"
								size="large"
								color="primary"
								:enabled="!isEmptyRequiredFields && modalReadOnly == false"
								:expand="null"
								:text="confirmText"
								@clicked="closeModal(true)">
							</spot-button>
						</div>
					</ion-content>
				</ion-modal>
				<ion-modal class="alert-settings" ref="alert" backdrop-dismiss="false" :is-open="isOpenAlert" @didDismiss="alertDismissed">
					<ion-content>
						<ion-toolbar>
							<ion-title> {{ confirmDeleteTitle }}</ion-title>
						</ion-toolbar>
						<div class="wrapper">
							<ion-label class="ion-text-wrap">{{ confirmDeleteMessage }}</ion-label>
							<br>
							<ion-label class="ion-text-wrap">{{	(tablesData.currentPick && tablesData.currentPick.item) ? tablesData.currentPick.item.description : '' }}</ion-label>
						</div>
						<div class="flex-row-center-container">
							<spot-button
								fill="outline"
								size="small"
								color="primary"
								:enabled="true"
								:expand="null"
								:text="undoText"
								@clicked="closeAlert(false)">
							</spot-button>
							<spot-button
								fill="outline"
								size="small"
								color="primary"
								:enabled="true"
								:expand="null"
								:text="confirmText"
								@clicked="closeAlert(true)">
							</spot-button>
						</div>
					</ion-content>
				</ion-modal>
			</div>
			<div id="debugArea" style="color:red;" v-if="settings.debug">
				<div>Test Area</div>
				<spot-button
					fill="outline"
					size="large"
					color="primary"
					:enabled="true"
					text="Simulate Scan"
					@clicked="onReadedBarcode('87196429','barcode')">
				</spot-button>
				<div v-for="field in fields" :key="field.id">
					{{ field.name }} = {{ field.value }}
				</div>
			</div>
		</ion-content>

 </ion-page>
</template>

<style scoped>
	.modal-settings {
		--height: 80%;
		--width: 90%;
		--border-radius: 16px;
		--box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
	}
	.alert-settings {
		--height: 50%;
		--width: 90%;
		--border-radius: 16px;
		--box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
	}
	.wrapper {
		padding-left: 3vw;
		padding-right: 3vw;
	}
	ion-modal::part(backdrop) {
		background: var(--ion-color-medium);
		opacity: 1;
	}
	ion-modal ion-toolbar {
		--background: var(--ion-color-primary);
		--color: white;
	}
	ion-textarea {
		font-size: 12px;
		margin-top: 5px;
		margin-bottom: 0px;
		--padding-top: 0px;
		--padding-bottom: 0px;
		--inner-padding-top: 0px;
		--inner-padding-bottom: 0px;
		--min-height: 0px
	}
	.flex-row-center-container {
		margin-top: 0.2em;
		text-align: center;
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
	}
	.no-pad {
		margin-top: 0px;
		margin-bottom: 0px;
		--padding-top: 0px;
		--padding-bottom: 0px;
		--inner-padding-top: 0px;
		--inner-padding-bottom: 0px;
		--min-height: 0px
	}
	*:deep(ion-checkbox) {
		margin-top: 0px;
		margin-bottom: 0px;
	}
</style>
<style>
	.empty-row  {
		--easy-table-body-row-background-color: var(--ion-color-danger); /*#f56c6c;*/
	}
	.partial-row  {
		--easy-table-body-row-background-color: var(--ion-color-warning); /*#ddc229;*/
	}
	.completed-row  {
		--easy-table-body-row-background-color: var(--ion-color-success); /*#67c23a;*/
	}
	.exceeded-row  {
		--easy-table-body-row-background-color: var(--ion-color-tertiary);/*#0d9de0;*/
	}
	.prominence-column {
		font-size: 20px;
	}
</style>

<script>
import { IonButton, IonContent, IonIcon, IonItem, IonLabel, IonModal, IonPage, IonProgressBar, IonTextarea, IonTitle, IonToolbar } from '@ionic/vue';
import { brush, duplicate, trash } from 'ionicons/icons';
import { defineComponent } from 'vue';
import SpotButton from '../components/SpotButton.vue';
import SpotCheckbox from '../components/SpotCheckbox.vue';
import SpotSelect from '../components/SpotSelect.vue';
import SpotInput from '../components/SpotInput.vue';
import SpotDate from '../components/SpotDate.vue';
import SpotHeader from "../components/SpotHeader.vue";
import WebSocketReader from '../components/WebSocketReader.vue';
import { checkUserSession, confirmYesNo, settings, showMsgError, showMsgInfo, showMsgWarning, writeLog } from '../plugins/common.js';
import { getBarcodeToSearch, getDateOnly, getItemTracking } from '../plugins/gs1Ai.js';
import { createPackage, createProjectRow, deletePackage, deleteProjectRow, deletePick, executePrinterAction, getLocations, getOrCreateItemSerialId, getPick, getPrinter, getProject, searchAdditionalBarcode, searchItem, searchLocation, searchPackages, searchPicks, searchPrinter, searchProjectRows, tablesData, updateItem, updateProjectRow, updatePick, updateProject } from '../plugins/customDatabase.js';

	export default defineComponent({
		name: "ManageAdvancedOrder",
		props: {
			pageTitle: { type: String, default: 'Gestisci Ordine' },
			noItemsText: { type: String, default: 'Nessun Articolo presente' },
			newItemText: { type: String, default: 'Nuovo Articolo' },
			editItemText: { type: String, default: 'Modifica Articolo'}, //'Modifica Articolo: '
			showItemText: { type: String, default: 'Visualizza Articolo'}, //'Visualizza Articolo: '
			printerName: {	type: String, default: 'Warehouse Printer' },
			isPrintingText: { type: String, default: 'Invio dati alla stampante... Attendere'},
			suspendText: { type: String, default: 'Esci/Sospendi' },
			closeText: { type: String, default: 'Concludi' },
			undoText: { type: String, default: 'Annulla' },
			confirmText: { type: String, default: 'Conferma' },
			unselected: { type: String, default: 'Nessuno' },
			selectedText: { type: String, default: 'Selezionato' },
			deselectText: { type: String, default: 'annulla' },
			selectText: { type: String, default: 'seleziona' },
			messageSearchItemTitle: { type: String, default: 'Ricerca Articolo' },
			messageSearchItemNotFound: { type: String, default: 'Articolo non trovato!' + '<br>' + 'Codice letto: ' },
			messageTitleCheckTAG: { type: String, default: 'Controllo TAG' },
			warnMultipleTAG: { type: String, default: 'Letto più di un TAG. Avvicinarsi solo al TAG da leggere e riprovare' },
			warnInavlidTAG: { type: String, default: 'TAG letto solo in parte. Riprovare a leggere' },
			confirmDeleteTitle: { type: String, default: 'Conferma Cancellazione' },
			confirmDeleteMessage: { type: String, default: 'Confermi la cancellazione delle letture effettuate per l\'articolo corrente?' },
			messageTitleReader: { type: String, default: 'Lettura Barcode/TAG' },
			errorReadingReader: { type: String, default: 'Errore nella lettura del barcode/tag' },
			messageTitleGs1: { type: String, default: 'Controllo GS1' },
			warnInvalidGs1: { type: String, default: 'Il codice letto non è un GS1 valido o non contiene il GTIN (01)!' + '<br>' + 'Codice letto: ' },
			lotCodeText: { type: String, default: 'Codice Lotto' },
			serialCodeText: { type: String, default: 'Codice Seriale' },
			messageTitleSerial: { type: String, default: 'Lotto / Seriale' },
			errorSerialNotSaved: { type: String, default: 'Impossibile recuperare o creare il Lotto/Seriale dell\'articolo!' },
			// messageTitleInsert: { type: String, default: "Inserimento Nuovo Collo" },
			// successAddPackageMessage: { type: String, default: "Nuovo collo inserito a sistema." },
			confirmExitTitle: { type: String, default: 'Conferma Uscita' },
			confirmExitMessage: { type: String, default: 'Sospensione! Se confermi l\'uscita, l\'ordine assumerà lo stato di sospeso e potrà essere riaperto successivamente. Confermi?' },
			confirmCloseMessage: { type: String, default: 'Evasione parziale! Confermi comunque la chiusura dell\'attività di impacchettamento?' }, // 'Confermi l\'uscita anche se non sono stati inseriti tutti i dati?'
			messageTitlePrint: { type: String, default: "Stampa Etichetta" },
			messageTitleInvalidQuantity: { type: String, default: "Quantità non valida" },
			warnExceededQuantity: { type: String, default: 'La Quantità inserita sommata alla Quantità rilevata in precedenza è superiore alla Quantità Prevista!' },
			warnNegativeQuantity: { type: String, default: 'Non è consentito inserire valori negativi nel campo Quantità!' },
			//successPrintMessage: { type: String, default: "Stampa etichetta avvenuta correttamente. Etichetta: " },
			successPrintMessage: { type: String, default: "Stampa etichetta avvenuta correttamente. Etichette stampate: " },
			errorPrintMessage: { type: String, default: "Errore durante la stampa dell'etichetta" },
			// errorPrintConfirmMessage: { type: String, default: "Confermi di procedere lo stesso anche se la stampa non è avvenuta (l'etichetta non potrà essere stampata successivamente)?" },
			warningPrinterOffline: { type: String, default: "La stampante non è raggiungibile; l'etichetta non è stata stampata" },
			warningUnassignedPrinterConfirmMessage: { type: String, default: "Confermi di procedere lo stesso anche se non è stata assegnata una stampante (l'etichetta non verrà stampata)?" },
			warningNotFoundPrinterConfirmMessage: { type: String, default: "Confermi di procedere lo stesso anche se la stampante è spenta o non raggiungibile (l'etichetta non verrà stampata)?" },
			confirmItemChangeTitle: { type: String, default: 'Conferma Cambio Articolo' },
			confirmItemChangeMessage: { type: String, default: 'Confermi di voler sostituire l\'articolo corrente?' },
		},
		components: {
			IonPage,
			IonContent,
			IonProgressBar,
			IonItem,
			IonButton,
			IonIcon,
			IonLabel,
			IonModal,
			IonToolbar,
			IonTitle,
			IonTextarea,
			SpotHeader,
			SpotInput,
			SpotCheckbox,
			SpotSelect,
			SpotDate,
			SpotButton,
			WebSocketReader,
		},
		data: () => ({
			isActive: null,
			field: {
				search: 0,
			},
			fields: [
				{ id: 0, name: 'search', text: 'Cerca: ', allignLabel: true, placeholder: 'Cerca Articolo', inputType: 'text', defaultValue: '', value: null, required: false, refField: null },
			],
			searchFields: ['item.code','item.description'],
			headers: [
				{ text: 'Descrizione', value: 'item.description', sortable: true },
				{ text: 'Azioni', value: 'actions', sortable: false }
				/*
				// { text: 'Ubicazione', value: 'location.name', sortable: true },
				{ text: 'Articolo', value: 'item.code', sortable: true },
				{ text: 'UM', value: 'item.measure_unit.name', sortable: false },
				{ text: 'Previsti', value: 'quantity', sortable: false },
				{ text: 'Rilevati', value: 'quantity_detected', sortable: false },
				// { text: 'Azioni', value: 'actions', sortable: false }
				*/
			],
			sortType: ['asc', 'asc'],
			sortBy: ['item.location.name','item.code'],
			itemContent: {
				// id: 0,
				code: 0, // 2,
				description: 1, // 3,
				// measureUnit: 2,
				location: 2,
				locations: 3,
				stock: 4,
				expectedQuantity: 5,
				quantity: 6,
				package: 7,
				lotSerial: 8,
				expiryDate: 9,
			},
			itemContents: [
				// { id: 0, name: 'id', text: 'Id', enabled: false, placeholder: 'Inserisci ID', inputType: "number", validationState: null, defaultValue: null, value: null, required: true },
				// { id: 1, name: 'location', text: 'Ubicazione', enabled: false, placeholder: 'Inserisci Ubicazione', inputType: "text", validationState: null, defaultValue: null, value: null, required: true },
				// { id: 2, name: 'code', text: 'Codice', enabled: false, placeholder: 'Inserisci Codice', inputType: "text", validationState: null, defaultValue: null, value: null, required: true },
				{ id: 0, name: 'code', text: 'Articolo', enabled: false, allignLabel: true, placeholder: 'Inserisci Codice Articolo', inputType: 'text', defaultValue: null, value: null, required: true, furtherInfo: null, validationState: null, canAddItem: false, canRefresh: false, canUnlock: false },
				// { id: 3, name: 'description', text: 'Descrizione', enabled: false, placeholder: 'Inserisci Descrizione', inputType: "text", validationState: null, defaultValue: null, value: null, required: true },
				{ id: 1, name: 'description', text: 'Descrizione', enabled: false, allignLabel: false, placeholder: 'Visualizza Descrizione', inputType: 'area', defaultValue: null, value: null, required: true, furtherInfo: null, validationState: null, canAddItem: false, canRefresh: false, canUnlock: false },
				// { id: 2, name: 'measureUnit', text: 'Unità di Misura', enabled: false, allignLabel: true, placeholder: 'Inserisci Unità di misura', inputType: "text", validationState: null, defaultValue: null, value: null, required: true },
				// { id: 3, name: 'location', text: 'Ubicazione', enabled: false, allignLabel: true, placeholder: 'Inserisci Ubicazione', inputType: "text", defaultValue: null, value: null, required: true, furtherInfo: null, validationState: null, canAddItem: false, canRefresh: false, canUnlock: false },
				{ id: 2, name: 'location', text: 'Ubicazione', enabled: false, enabledExtraButtons: false, allignLabel: true, placeholder: 'Inserisci Ubicazione', inputType: "select", defaultValue: null, value: null, required: true, furtherInfo: null, refField: 'name', validationState: null, canAddItem: false, canRefresh: false, canUnlock: false },
				{ id: 3, name: 'locations', text: 'Ubicazioni', enabled: false, allignLabel: false, placeholder: 'Visualizza Posizioni', inputType: 'area', defaultValue: null, value: null, required: true, furtherInfo: null, validationState: null, canAddItem: false, canRefresh: false, canUnlock: false },
				{ id: 4, name: 'stock', text: 'Giacenza', enabled: false, allignLabel: true, placeholder: 'Inserisci Giacenza', inputType: 'number', defaultValue: null, value: null, required: true, furtherInfo: null, validationState: null, canAddItem: false, canRefresh: false, canUnlock: false },
				// { id: 4, name: 'expectedQuantity', text: 'Quantità Prevista', enabled: false, placeholder: 'Inserisci Quantità Prevista', inputType: "number", validationState: null, defaultValue: null, value: null, required: true },
				{ id: 5, name: 'expectedQuantity', text: 'Quantità Prevista', enabled: false, allignLabel: false, placeholder: 'Inserisci Quantità Prevista', inputType: 'number', defaultValue: null, value: null, required: true, furtherInfo: null, validationState: null, canAddItem: false, canRefresh: false, canUnlock: false },
				// { id: 5, name: 'quantity', text: 'Quantità Rilevata', enabled: true, placeholder: 'Inserisci Quantità Rilevata', inputType: "number", validationState: null, defaultValue: null, value: null, required: true },
				{ id: 6, name: 'quantity', text: 'Quantità', enabled: true, allignLabel: true, placeholder: 'Inserisci Quantità', inputType: 'number',  defaultValue: null, value: null, required: true, furtherInfo: null, validationState: null, canAddItem: false, canRefresh: false, canUnlock: false },
				{ id: 7, name: 'package', text: 'Collo', enabled: true, enabledExtraButtons: true, allignLabel: true, placeholder: 'Inserisci Collo', inputType: 'select', defaultValue: null, value: null, required: true, refField: 'name', validationState: null, canAddItem: true, canRefresh: false, canUnlock: false },
				{ id: 8, name: 'lotSerial', text: 'Codice Lotto', enabled: false, visible: false, allignLabel: true, placeholder: 'Inserisci Codice', inputType: 'text', defaultValue: null, value: null, required: false, furtherInfo: null, validationState: null, canAddItem: false, canRefresh: false, canUnlock: false },
				{ id: 9, name: 'expiryDate', text: 'Data di Scadenza', enabled: false, visible: false, allignLabel: true, placeholder: 'Inserisci Data di Scadenza', inputType: 'datetime', defaultValue: null, value: null, required: false, furtherInfo: null, validationState: null, canAddItem: false, canRefresh: false, canUnlock: false },
			],
			isOpenModal: false,
			isOpenAlert: false,
			isPrinting: false,
			modalTitle: null,
			modalReadOnly: null,
			actionDbCreate: null,
			isIncoming: null,
			isOutgoing: null,
			isPicking: null,
			isRevision: null,
			isLocked: null,
			projectId: null,
			printerId: null,
			lastBarcode: null,
			lastGs1: null,
			lastTag: null,
			itemTracking: null,
			forceSerialQuantity: false, //true = Quantity forced to 1 for items with serials; false = Free quantity (some suppliers use SERIAL (21) as lot)
			assignRemaingQuantity: false,
			allowExceededQuantity: true,
			allowNegativeQuantity: false,
			isStartedRowAction: false,
			isChangedLocation: false,
			duplicate,
			trash,
			brush,
			settings,
			checkUserSession,
			confirmYesNo,
			showMsgError,
			showMsgInfo,
			showMsgWarning,
			writeLog,
			getBarcodeToSearch,
			getDateOnly,
			getItemTracking,
			getOrCreateItemSerialId,
			getLocations,
			getPick,
			getPrinter,
			getProject,
			searchPicks,
			searchAdditionalBarcode,
			searchItem,
			searchLocation,
			searchProjectRows,
			searchPackages,
			searchPrinter,
			createProjectRow,
			createPackage,
			updatePick,
			updateProjectRow,
			deletePackage,
			deletePick,
			deleteProjectRow,
			updateItem,
			updateProject,
			executePrinterAction,
			tablesData,
		}),
		async ionViewWillEnter() {
			this.getUrlParamsAndQuery();
			this.setDefault();
			await this.getAllTablesData();
			this.isActive = true;
		},
		ionViewWillLeave() {
			this.isOpenModal = false;
			this.isOpenAlert = false;
			this.isPrinting = false;
			this.isActive=false;
		},
		computed: {
			visibleItemContents() {
				return this.itemContents.filter(element => element.visible != false);
			},
			isEmptyRequiredFields() {
				let ret = false;
				this.itemContents.forEach(element => {if (element.required && !element.value && element.id > 0) ret=true});
				return ret;
			},
			/*
			isOrderClean() {
				let ret = true;
				this.tablesData.picks.forEach(element => {if (element.quantity_detected > 0) ret=false});
				return ret;
			},
			isOrderFinished() {
				let ret = true;
				this.tablesData.picks.forEach(element => {if (element.quantity != element.quantity_detected) ret=false});
				return ret;
			},
			*/
			canPrint() {
				return (this.settings.printerManagement && (this.printerId != null))
			},
			checkQuantity() {
				let ret = true;
				if (!this.allowNegativeQuantity) {
					if ((parseFloat(this.itemContents[this.itemContent.quantity].value)) < parseFloat(0)) {
						this.showMsgWarning(this.messageTitleInvalidQuantity, this.warnNegativeQuantity);
						ret = false;
					}
				}
				if (ret == true && !this.allowExceededQuantity) {
					if ((parseFloat(this.tablesData.currentPick.quantity_detected) + parseFloat(this.itemContents[this.itemContent.quantity].value)) > parseFloat(this.tablesData.currentPick.quantity)) {
						this.showMsgWarning(this.messageTitleInvalidQuantity, this.warnExceededQuantity);
						ret = false;
					}
				}
				return ret;
			},
		},
		setup() {
			const bodyRowClassNameFunction = (item) => {
				if (parseFloat(item.quantity_detected) == parseFloat(item.quantity)) return 'completed-row'
				else if(parseFloat(item.quantity_detected) == parseFloat(0)) return 'empty-row'
				else if(parseFloat(item.quantity_detected) < parseFloat(item.quantity)) return 'partial-row'
				else return 'exceeded-row';
			}
			const bodyItemClassNameFunction = (column) => {
				if (column === 'quantity' || column === 'quantity_detected') return 'prominence-column';
				else return '';
			};
			return {
				bodyRowClassNameFunction,
				bodyItemClassNameFunction,
			};
		},
		methods: {
			// Settings & StartUp
			getUrlParamsAndQuery() {
				this.isIncoming = (/true/i).test(this.$route.query.incoming);
				this.isOutgoing = (/true/i).test(this.$route.query.outgoing);
				this.isPicking = (/true/i).test(this.$route.query.picking);
				this.isRevision = (/true/i).test(this.$route.query.revision);
				this.isLocked = (/true/i).test(this.$route.query.locked);
				this.projectId = this.$route.params.id;
			},
			setDefault() {
				this.fields.forEach(element => element.value = element.defaultValue);
				if (this.isIncoming) {
					this.itemContents[this.itemContent.location].enabled = true;
					this.itemContents[this.itemContent.package].enabled = false;
					this.itemContents[this.itemContent.package].enabledExtraButtons = false;
					this.itemContents[this.itemContent.package].required = false;
				}
				this.isOpenModal = false;
				this.isOpenAlert = false;
				this.isPrinting = false;
				this.modalTitle = null;
				this.modalReadOnly = null;
				this.actionDbCreate = null;
				this.lastBarcode = null;
				this.lastGs1 = null;
				this.lastTag = null;
				this.itemTracking = null;
				this.isStartedRowAction = false;
				this.isChangedLocation = false;
			},
			getPlaceHolder(element) {
				return ((this.settings.showFieldsPlaceholder) ? (element.required ? element.placeholder : this.unselected ) : ' ')
			},
			getOptions(elementId) {
				let myOption = null;
				switch (elementId) {
					case this.itemContent.location:
						myOption = this.tablesData.locations;
						break
					case this.itemContent.package:
						myOption = this.tablesData.packages;
						break
					default:
						//Do Nothing
						break
				}
				return myOption;
			},
			// Database
			async getAllTablesData(checkPrinter = true) {
				await this.getProject(this.projectId);
				this.tablesData.locations = [];
				await this.getLocations();
				// this.tablesData.projectRows = [];
				this.tablesData.picks = [];
				// await this.searchProjectRows(this.projectId);
				await this.searchPicks(this.projectId);
				this.tablesData.packages = [];
				await this.searchPackages(this.projectId, false, false);
				if (this.settings.printerManagement == true && checkPrinter == true) {
					this.tablesData.printers = [];
					this.tablesData.currentPrinter = null;
					await this.searchPrinter(null,this.printerName);
					if (!this.tablesData.currentPrinter) {
						this.printerId = null;
						this.confirmYesNo(this.messageTitlePrint, this.warningUnassignedPrinterConfirmMessage)
						.then((data) => {
							if (data == false) {
								this.$router.push("/order/advanced/selection" + "?incoming=" + this.isIncoming + "&outgoing=" + this.isOutgoing + "&picking=" + this.isPicking)
							}
						})
					}
					else {
						this.printerId = this.tablesData.currentPrinter.id;
						if (!this.tablesData.currentPrinter.is_online) {
							this.confirmYesNo(this.messageTitlePrint, this.warningNotFoundPrinterConfirmMessage)
							.then((data) => {
								if (data == false) {
									this.$router.push("/order/advanced/selection" + "?incoming=" + this.isIncoming + "&outgoing=" + this.isOutgoing + "&picking=" + this.isPicking)
								}
							})
						}
					}
				}
			},
			async deleteExistingPick(pick) {
				let canDelete = false;
				await this.confirmYesNo(this.confirmDeleteTitle, this.confirmDeleteMessage)
					.then((data) => { canDelete = data })
				if (canDelete == true) {
					await this.deletePick(pick.id)
				}
			},
			async deleteExistingProjectRow(projectRow) {
				let canDelete = false;
				await this.confirmYesNo(this.confirmDeleteTitle, this.confirmDeleteMessage)
					.then((data) => { canDelete = data })
				if (canDelete == true) {
					await this.deleteProjectRow(projectRow.id)
				}
			},
			async deleteProjectRowsInPick(pick) {
				this.isStartedRowAction = true;
				let canDelete = false;
				await this.confirmYesNo(this.confirmDeleteTitle, this.confirmDeleteMessage)
				.then((data) => { canDelete = data })
				if (canDelete == true) {
					for (let i = 0; i < pick.project_rows.length; i++) {
						await this.deleteProjectRow(pick.project_rows[i].id, false)
					}
				}
				await this.getAllTablesData(false);
				this.isStartedRowAction = false;				
			},
			// Actions
			async onReadedBarcode(barcode, type, gs1Data = null) {
				this.writeLog(barcode, type, gs1Data);
				let barcodeToSearch = this.getBarcodeToSearch(barcode, type, gs1Data, this.settings.manageGs1Ai);
				this.lastBarcode = barcodeToSearch.barcode;
				this.lastGs1 = barcodeToSearch.gs1Data;
				if (barcodeToSearch.result == false) {
					this.showMsgWarning(this.messageTitleGs1, this.warnInvalidGs1 + barcode);
					return;
				}
				await this.committedBarcode();
			},
			async onReadedTag(tag,type) {
				this.lastTag = tag;
				this.writeLog(tag, type);
				await this.committedTag();
			},
			onReaderError(data,error) {
				this.showMsgError(data, error);
				this.showMsgWarning(this.messageTitleReader, this.errorReadingReader);
			},
			changedSearch(value) {
				this.fields[this.field.search].value = value;
			},
			changedTextField(fieldId, value) {
				this.itemContents[fieldId].value = value;
				(!value || value.length == 0)? this.itemContents[fieldId].validationState = false : this.itemContents[fieldId].validationState = true
			},
			changedDateField(fieldId, value) {
				this.itemContents[fieldId].value = value;
				(!value || value.length == 0)? this.itemContents[fieldId].validationState = false : this.itemContents[fieldId].validationState = true
			},
			changedCheckboxField(fieldId, value) {
				this.itemContents[fieldId].value = value;
				(!value || value.length == 0)? this.itemContents[fieldId].validationState = false : this.itemContents[fieldId].validationState = true
			},
			assignedSelectField(fieldId, value) {
				if (this.isIncoming && (fieldId == this.itemContent.location)) {
					this.isChangedLocation = true;
				}
				this.itemContents[fieldId].value = value;
				(!value)? this.itemContents[fieldId].validationState = false : this.itemContents[fieldId].validationState = true
			},
			resetSelectField(fieldId) {
				this.itemContents[fieldId].value = null;
				this.itemContents[fieldId].validationState = false
			},
			async addPackage() {
				this.tablesData.currentPackage = null;
				await this.createPackage(this.prepareNewPackage(),false);
				await this.searchPackages(this.projectId, false, false);
				if (this.tablesData.currentPackage != null) {
					this.itemContents[this.itemContent.package].value = this.tablesData.currentPackage;
					this.itemContents[this.itemContent.package].validationState = true;
					return true;
				}
				else {
					return false;
				}
			},
			prepareUpdateItem() {
				let myRecord = {
					items: {
						location_id: this.itemContents[this.itemContent.location].value.id,
					}
				};
				return myRecord;
			},
			prepareNewProjectRow(serialId = null) {
				let myRecord = {
					project_rows: {
						project_id: this.tablesData.currentPick.project_id, // this.projectId
						pick_id: this.tablesData.currentPick.id,
						location_id: (!this.isIncomong)? this.tablesData.currentPick.location.id : this.tablesData.currentPick.item.location.id,
						item_id: this.tablesData.currentPick.item.id,
						quantity: this.itemContents[this.itemContent.quantity].value,
						package_id: (!this.itemContents[this.itemContent.package].value)? null : this.itemContents[this.itemContent.package].value.id,
					}
				};
				if (serialId != null) myRecord.project_rows.serial_id = serialId;
				this.writeLog(myRecord.project_rows);
				return myRecord;
			},
			prepareNewPackage() {
				let myRecord = {
					packages: {
						project_id: this.projectId,
						closed: false,
						shipped: false,
					}
				};
				return myRecord;
			},
			prepareUpdateProjectRow() {
				let myRecord = {
					project_rows: {
						quantity: this.itemContents[this.itemContent.quantity].value,
					}
				};
				return myRecord;
			},
			prepareUpdatePick(isClosed) {
				let myRecord = {
					picks: {
						closed: isClosed,
					}
				};
				return myRecord;
			},
			updateItemContents(row) {
				Object.getOwnPropertyNames(row).forEach(rowField => {
					this.itemContents.forEach(pageElement => {
						if (rowField == pageElement.name) {
							pageElement.value = row[rowField];
						}
					});
				});
			},
			setItemTrackingContents(item, gs1Data = null) {
				let tracking = this.getItemTracking(item, gs1Data, this.settings.manageGs1Ai);
				let lotSerial = this.itemContents[this.itemContent.lotSerial];
				let expiryDate = this.itemContents[this.itemContent.expiryDate];
				this.itemTracking = tracking.type;
				lotSerial.visible = (tracking.type != null);
				lotSerial.required = lotSerial.visible;
				lotSerial.text = (tracking.type == 'serial') ? this.serialCodeText : this.lotCodeText;
				lotSerial.value = tracking.code;
				lotSerial.enabled = (lotSerial.visible && !tracking.code);
				lotSerial.validationState = (!lotSerial.visible) ? null : !!tracking.code;
				expiryDate.visible = (tracking.type == 'lot');
				expiryDate.required = expiryDate.visible;
				expiryDate.value = tracking.expiryDate;
				expiryDate.enabled = (expiryDate.visible && !tracking.expiryDate);
				expiryDate.validationState = (!expiryDate.visible) ? null : !!tracking.expiryDate;
				if (tracking.type == 'serial' && this.forceSerialQuantity == true) {
					this.itemContents[this.itemContent.quantity].value = 1;
					this.itemContents[this.itemContent.quantity].enabled = false;
				}
				else {
					this.itemContents[this.itemContent.quantity].enabled = true;
				}
			},
			createCustomItemContents(pickRow) {
				this.itemContents[this.itemContent.code].value = pickRow.item.code
				this.itemContents[this.itemContent.description].value = pickRow.item.description
				// this.itemContents[this.itemContent.measure_unit].value = pickRow.item.measure_unit.name
				this.itemContents[this.itemContent.location].value = pickRow.item.location
				this.itemContents[this.itemContent.locations].value = (pickRow.item.locations.length > 0)? pickRow.item.locations.map((element) => element.name) + '': ' '
				this.itemContents[this.itemContent.stock].value = pickRow.item.quantity
				this.itemContents[this.itemContent.stock].furtherInfo = (pickRow.item.locked_quantity > 0)? ' (Disponibili: ' + (parseFloat(pickRow.item.quantity) - parseFloat(pickRow.item.locked_quantity)) + ')': null
				this.itemContents[this.itemContent.expectedQuantity].value = pickRow.quantity
				this.itemContents[this.itemContent.expectedQuantity].furtherInfo = (pickRow.quantity_detected > 0)? ' (Già inseriti: ' + parseFloat(pickRow.quantity_detected) + ')': null
				this.itemContents[this.itemContent.quantity].value = (!this.assignRemaingQuantity)? null : (parseFloat(pickRow.quantity) - parseFloat(pickRow.quantity_detected))
				this.itemContents[this.itemContent.quantity].furtherInfo = pickRow.item.measure_unit.name
				//this.itemContents[this.itemContent.quantity].furtherInfo = ' / ' + (parseFloat(pickRow.quantity) - parseFloat(pickRow.quantity_detected))
				this.itemContents[this.itemContent.package].value = null
			},
			updateCustomItemContents(row) {
				this.itemContents[this.itemContent.id].value = row.project_row.id
				this.itemContents[this.itemContent.code].value = row.item.code
				this.itemContents[this.itemContent.description].value = row.item.description
				// this.itemContents[this.itemContent.measure_unit].value = row.item.measure_unit.name
				this.itemContents[this.itemContent.location].value = row.item.location
				this.itemContents[this.itemContent.locations].value = (row.item.locations.length > 0)? row.item.locations.map((element) => element.name) + '': ' '
				this.itemContents[this.itemContent.stock].value = row.item.quantity
				this.itemContents[this.itemContent.stock].furtherInfo = (row.item.locked_quantity > 0)? ' (Disponibili: ' + (parseFloat(row.item.quantity) - parseFloat(row.item.locked_quantity)) + ')': null
				this.itemContents[this.itemContent.expectedQuantity].value = parseInt(row.quantity)
				this.itemContents[this.itemContent.expectedQuantity].furtherInfo = (row.quantity_detected > 0)? ' (Già inseriti: ' + parseFloat(row.quantity_detected) + ')': null
				this.itemContents[this.itemContent.quantity].value = parseInt(row.quantity_detected)
				this.itemContents[this.itemContent.quantity].furtherInfo = row.item.measure_unit.name
			},
			createNewPick() {
				this.itemContents.forEach(element => element.value = element.defaultValue);
				this.itemContents.forEach(element => (element.required == true? (element.value == null && element.id > 0 ? element.validationState = false : element.validationState = true) : element.validationState = null));
				this.modalTitle = this.newItemText;
				this.actionDbCreate = true;
				this.openModal(false);
			},
			async createNewProjectRow(tableRow, gs1Data = null) { // gs1Data is null when the item is clicked from the list
				if (!this.isStartedRowAction) {
					this.writeLog(tableRow);
					if (!tableRow) {
						this.itemContents.forEach(element => element.value = element.defaultValue);
						this.setItemTrackingContents(null);
					}
					else {
						this.tablesData.currentPick = tableRow;
						await this.getPick(tableRow.id);
						this.createCustomItemContents(this.tablesData.currentPick);
						this.setItemTrackingContents(this.tablesData.currentPick.item, gs1Data);
					}
					this.itemContents.forEach(element => (element.required == true? (element.value == null && element.id > 0 ? element.validationState = false : element.validationState = true) : element.validationState = null));
					this.modalTitle = this.newItemText;
					this.actionDbCreate = true;
					this.openModal(false);
				}
			},
			async editExistingPick(pick) {
				this.updateCustomItemContents(pick);
				this.itemContents.forEach(element => (element.required == true? (element.value == null && element.id > 0 ? element.validationState = false : element.validationState = true) : element.validationState = null));
				this.modalTitle = this.editItemText // + pick.item.code;
				this.actionDbCreate = false;
				this.openModal(false);
			},
			async editExistingProjectRow(projectRow) {
				this.updateCustomItemContents(projectRow);
				this.itemContents.forEach(element => (element.required == true? (element.value == null && element.id > 0 ? element.validationState = false : element.validationState = true) : element.validationState = null));
				this.modalTitle = this.editItemText // + projectRow.item.code;
				this.actionDbCreate = false;
				this.openModal(false);
			},
			async showExistingPick(pick) {
				this.updateCustomItemContents(pick);
				this.itemContents.forEach(element => (element.required == true? (element.value == null && element.id > 0 ? element.validationState = false : element.validationState = true) : element.validationState = null));
				this.modalTitle = this.showItemText // + pick.item.code;
				this.actionDbCreate = false;
				this.openModal(true);
			},
			async showExistingProjectRow(projectRow) {
				this.updateCustomItemContents(projectRow);
				this.itemContents.forEach(element => (element.required == true? (element.value == null && element.id > 0 ? element.validationState = false : element.validationState = true) : element.validationState = null));
				this.modalTitle = this.showItemText // + projectRow.item.code;
				this.actionDbCreate = false;
				this.openModal(true);
			},
			openModal(isReadOnly) {
				this.modalReadOnly = isReadOnly;
				this.isChangedLocation = false;
				this.isOpenModal = true;
			},
			async closeModal(saveRecord) {
				let canCloseModal = true;
				if (saveRecord == true) {
					if (this.checkQuantity) {
						let serialId = null;
						if (this.actionDbCreate == true && this.itemTracking != null) {
							serialId = await this.getOrCreateItemSerialId(
								this.tablesData.currentPick.item.id,
								this.itemContents[this.itemContent.lotSerial].value,
								(this.itemTracking == 'lot') ? this.getDateOnly(this.itemContents[this.itemContent.expiryDate].value) : null);
							if (serialId == null) {
								this.showMsgError(this.messageTitleSerial, this.errorSerialNotSaved);
								return;
							}
						}
						if (this.isChangedLocation == true) {
							await this.updateItem(this.tablesData.currentPick.item.id, this.prepareUpdateItem(), false);
							this.tablesData.currentPick.item = this.tablesData.currentItem;
						}
						if (this.actionDbCreate == true) {
							await this.createProjectRow(this.prepareNewProjectRow(serialId), false)
						}
						else {
							await this.updateProjectRow(this.itemContents[this.itemContent.id].value, this.prepareUpdateProjectRow(), false)
						}
						if ((parseFloat(this.tablesData.currentPick.quantity_detected) + parseFloat(this.itemContents[this.itemContent.quantity].value)) >= parseFloat(this.tablesData.currentPick.quantity)) {
							await this.updatePick(this.tablesData.currentPick.id, this.prepareUpdatePick(true), false)
						} else {
							await this.updatePick(this.tablesData.currentPick.id, this.prepareUpdatePick(false), false)
						}
					}
					else {
						canCloseModal = false;
					}
				}
				if (canCloseModal) {
					await this.getAllTablesData(false);
					this.isOpenModal = false;
				}
			},
			async modalDismissed() {
				this.actionDbCreate = null;
			},
			async openAlert(tableRow) {
				this.isStartedRowAction = true;
				this.tablesData.currentPick = tableRow;
				await this.getPick(tableRow.id);
				this.isOpenAlert = true;
			},
			async closeAlert(deleteRecord) {
				if (deleteRecord == true) {
					for (let i = 0; i < this.tablesData.currentPick.project_rows.length; i++) {
						await this.deleteProjectRow(this.tablesData.currentPick.project_rows[i].id, false)
					}
					await this.getAllTablesData(false);
				}
				this.isStartedRowAction = false;
				this.isOpenAlert = false;
			},
			async alertDismissed() {
				this.actionDbCreate = null;
			},
			changedBarcode(value) {
				this.lastBarcode = value;
			},
			async searchBarcodeInProjectPicks() {
				let ret = null;
				this.tablesData.picks.some(element => {
					if (element.item.barcode == this.lastBarcode) {
						ret = element;
						return true;
					}
					if (element.item.additional_barcodes.length > 0) {
						element.item.additional_barcodes.some(subElement => {
							if (subElement.code == this.lastBarcode) {
								ret = element;
								return true;
							}
						})
					}
				});
				return ret;
			},
			async searchBarcodeInProjectPackages() {
				let ret = null;
				this.tablesData.packages.some(element => {
					if (element.name == this.lastBarcode) {
						ret = element;
						return true;
					}
				});
				return ret;
			},
			async searchBarcodeInTables() {
				let ret = null;
				this.tablesData.currentItem = null;
				this.tablesData.currentAdditionalBarcode = null;
				await this.searchItem(null,this.lastBarcode);
				if (!this.tablesData.currentItem) {
					await this.searchAdditionalBarcode(this.lastBarcode);
					if (!this.tablesData.currentAdditionalBarcode) {
						this.showMsgWarning(this.messageSearchItemTitle, this.messageSearchItemNotFound + this.lastBarcode);
					}
					else {
						ret = this.tablesData.currentAdditionalBarcode.item;
					}
				}
				else {
					ret = this.tablesData.currentItem;
				}
				return ret;
			},
			async committedBarcode() {
				let foundElement = null;
				if (this.isOpenModal == false) {
					foundElement = await this.searchBarcodeInProjectPicks();
					if (!foundElement) this.showMsgWarning(this.messageSearchItemTitle, this.messageSearchItemNotFound + this.lastBarcode);
					else await this.createNewProjectRow(foundElement, this.lastGs1); // editExistingPick(foundElement);
				}
				else { // Qua ci si può mettere anche la sostituzione di un articolo
					foundElement = await this.searchBarcodeInProjectPackages();
					if (!foundElement) {
						foundElement = await this.searchBarcodeInTables();
						if (foundElement != null) {
							await this.confirmYesNo(this.confirmItemChangeTitle, this.confirmItemChangeMessage)
							.then((data) => {
								if (data == true) {
									this.tablesData.currentPick.item = foundElement;
									this.itemContents[this.itemContent.code].value = foundElement.code
									this.itemContents[this.itemContent.code].validationState = true
									this.itemContents[this.itemContent.description].value = foundElement.description
									this.itemContents[this.itemContent.location].value = foundElement.location
									this.itemContents[this.itemContent.locations].value = (foundElement.locations.length > 0)? foundElement.locations.map((element) => element.name) + '': ' '
									this.itemContents[this.itemContent.stock].value = foundElement.quantity
									this.itemContents[this.itemContent.stock].furtherInfo = (foundElement.locked_quantity > 0)? ' (Disponibili: ' + (parseFloat(foundElement.quantity) - parseFloat(foundElement.locked_quantity)) + ')': null
									this.itemContents[this.itemContent.quantity].furtherInfo = foundElement.measure_unit.name
									this.setItemTrackingContents(foundElement, this.lastGs1);
								}
							})
						}
						else {
							this.showMsgWarning(this.messageSearchPackageTitle, this.messageSearchPackageNotFound);
						}
					}
					else {
						this.assignedSelectField(this.itemContents[this.itemContent.package].id, foundElement);
					}
				}
			},
			changedTag(value) {
				this.lastTag = value;
			},
			async committedTag() {
				let tagElements = this.lastTag.split('|');
				let foundElement = null;

				switch (tagElements.length) {
					case 0:
						this.lastTag = null;
						this.showMsgWarning(this.messageTitleCheckTAG,this.warnInavlidTAG);
						break;
					case 1:
						this.tablesData.picks.some(pick => {
							if (pick.item.code == this.lastTag) {
								foundElement = pick;
								return true;
							}
						});
						if (!foundElement) this.showMsgWarning(this.messageSearchItemTitle, this.messageSearchItemNotFound + this.lastTag);
						else this.editExistingPick(foundElement);
						break;
					default:
						this.lastTag = null;
						this.showMsgWarning(this.messageTitleCheckTAG,this.warnMultipleTAG);
						break;
				}
			},
			preparePrinterData(packageNumber, packageName) { //
				`?x=${encodeURIComponent('test?')}`
				/*let retString = '?do=print_single_barcode&current_date=23%2F07%2F2024&customer_external_code=12345&customer_name=TORTONA%20TURKISH%20KEBAP%202%20DI%20AKBIVIK%20SAKIR%20E%20DI%20GABRIELE%20GIANLUCA%20CIAO&customer_address=CENTRO%20COMMERCIALE%20%20%22NUOVO%20BORGO%22%20CORSO%20CASALE%20N.319&customer_postal_code=40139&customer_locality=FRAZ.%20VALLE%20SAN%20BARTOLOMEO%20-%20ALESSANDRIA&customer_province=AL&package_incremental=1&project_packages_number=2&item_0_quantity=999&item_0_description=GUANTO%20BANCO%20NITRILE%20NERO%20GRIP%207,2%20GR%20PZ.50%20REINDOSSABILE%20NON%20USARE%20CERCARE%20CODICI%20MISURA&item_1_quantity=3&item_1_description=FAIRY%20LAVASTOVIGLIE%20ALL%20IN%20ONE%20PLATINUM%2075%20CAPS%20NEW%20FORMULA&item_2_quantity=10&item_2_description=CANDEGGINA%20LT.1&item_3_quantity=99&item_3_description=GUANTO%20BANCO%20NITRILE%20NERO%20GRIP%207,2%20GR%20PZ.50%20REINDOSSABILE%20NON%20USARE%20CERCARE%20CODICI%20MISURA&item_4_quantity=999&item_4_description=SACCHETTI%20BIANCHI%205%20cm.%2019x40&item_5_quantity=3&item_5_description=BIS%20POSATE%20STYLE%2033X33%20P%2F8%20BYO'%20PZ.500&item_6_quantity=10&item_6_description=ROTOLO%20TOVAGLIA%20TNT%20H.160cm.x%2010mt.PANNA&item_7_quantity=99&item_7_description=CARTA%20ACC.CARTENE%2033x44%20ST.FORNO&item_8_quantity=10&item_8_description=FAIRY%20LAVASTOVIGLIE%20ALL%20IN%20ONE%20PLATINUM%2075%20CAPS%20NEW%20FORMULA&item_9_quantity=99&item_9_description=GUANTO%20BANCO%20NITRILE%20NERO%20GRIP%207,2%20GR%20PZ.50%20REINDOSSABILE%20NON%20USARE%20CERCARE%20CODICI%20MISURA';*/

				let retString = `?do=print_single_barcode`;
				retString += `&current_date=${encodeURIComponent(new Date().toLocaleDateString('it-IT'))}`;
				retString += `&customer_external_code=${encodeURIComponent((!this.tablesData.currentProject.customer)? '' : this.tablesData.currentProject.customer.external_code)}`;
				if (!this.tablesData.currentProject.address) {
					if (!this.tablesData.currentProject.customer) {
						retString += `&customer_name=`;
						retString += `&customer_address=`;
						retString += `&customer_postal_code=`;
						retString += `&customer_locality=`;
						retString += `&customer_province=`;
					} else {
						retString += `&customer_name=${encodeURIComponent((!this.tablesData.currentProject.customer.name)? '' : this.tablesData.currentProject.customer.name)}`;
						retString += `&customer_address=${encodeURIComponent((!this.tablesData.currentProject.customer.address)? '' : this.tablesData.currentProject.customer.address)}`;
						retString += `&customer_postal_code=${encodeURIComponent((!this.tablesData.currentProject.customer.postal_code)? '' : this.tablesData.currentProject.customer.postal_code)}`;
						retString += `&customer_locality=${encodeURIComponent((!this.tablesData.currentProject.customer.locality)? '' : this.tablesData.currentProject.customer.locality)}`;
						retString += `&customer_province=${encodeURIComponent((!this.tablesData.currentProject.customer.province)? '' : this.tablesData.currentProject.customer.province)}`;
					}
				} else {
					retString += `&customer_name=${encodeURIComponent((!this.tablesData.currentProject.address.name)? '' : this.tablesData.currentProject.address.name)}`;
					retString += `&customer_address=${encodeURIComponent((!this.tablesData.currentProject.address.address)? '' : this.tablesData.currentProject.address.address)}`;
					retString += `&customer_postal_code=${encodeURIComponent((!this.tablesData.currentProject.address.postal_code)? '' : this.tablesData.currentProject.address.postal_code)}`;
					retString += `&customer_locality=${encodeURIComponent((!this.tablesData.currentProject.address.locality)? '' : this.tablesData.currentProject.address.locality)}`;
					retString += `&customer_province=${encodeURIComponent((!this.tablesData.currentProject.address.province)? '' : this.tablesData.currentProject.address.province)}`;
				}
				retString += `&package_incremental=${encodeURIComponent(packageNumber)}`;
				retString += `&project_packages_number=${encodeURIComponent(this.tablesData.packages.length)}`;
				retString += `&package_name=${encodeURIComponent(packageName)}`;
				retString += `&item_0_quantity=${encodeURIComponent((!this.tablesData.projectRows[0])? '' : this.tablesData.projectRows[0].quantity)}`;
				retString += `&item_0_description=${encodeURIComponent((!this.tablesData.projectRows[0])? '' : this.tablesData.projectRows[0].item.description)}`;
				retString += `&item_1_quantity=${encodeURIComponent((!this.tablesData.projectRows[1])? '' : this.tablesData.projectRows[1].quantity)}`;
				retString += `&item_1_description=${encodeURIComponent((!this.tablesData.projectRows[1])? '' : this.tablesData.projectRows[1].item.description)}`;
				retString += `&item_2_quantity=${encodeURIComponent((!this.tablesData.projectRows[2])? '' : this.tablesData.projectRows[2].quantity)}`;
				retString += `&item_2_description=${encodeURIComponent((!this.tablesData.projectRows[2])? '' : this.tablesData.projectRows[2].item.description)}`;
				retString += `&item_3_quantity=${encodeURIComponent((!this.tablesData.projectRows[3])? '' : this.tablesData.projectRows[3].quantity)}`;
				retString += `&item_3_description=${encodeURIComponent((!this.tablesData.projectRows[3])? '' : this.tablesData.projectRows[3].item.description)}`;
				retString += `&item_4_quantity=${encodeURIComponent((!this.tablesData.projectRows[4])? '' : this.tablesData.projectRows[4].quantity)}`;
				retString += `&item_4_description=${encodeURIComponent((!this.tablesData.projectRows[4])? '' : this.tablesData.projectRows[4].item.description)}`;
				retString += `&item_5_quantity=${encodeURIComponent((!this.tablesData.projectRows[5])? '' : this.tablesData.projectRows[5].quantity)}`;
				retString += `&item_5_description=${encodeURIComponent((!this.tablesData.projectRows[5])? '' : this.tablesData.projectRows[5].item.description)}`;
				retString += `&item_6_quantity=${encodeURIComponent((!this.tablesData.projectRows[6])? '' : this.tablesData.projectRows[6].quantity)}`;
				retString += `&item_6_description=${encodeURIComponent((!this.tablesData.projectRows[6])? '' : this.tablesData.projectRows[6].item.description)}`;
				retString += `&item_7_quantity=${encodeURIComponent((!this.tablesData.projectRows[7])? '' : this.tablesData.projectRows[7].quantity)}`;
				retString += `&item_7_description=${encodeURIComponent((!this.tablesData.projectRows[7])? '' : this.tablesData.projectRows[7].item.description)}`;
				retString += `&item_8_quantity=${encodeURIComponent((!this.tablesData.projectRows[8])? '' : this.tablesData.projectRows[8].quantity)}`;
				retString += `&item_8_description=${encodeURIComponent((!this.tablesData.projectRows[8])? '' : this.tablesData.projectRows[8].item.description)}`;
				retString += `&item_9_quantity=${encodeURIComponent((!this.tablesData.projectRows[9])? '' : this.tablesData.projectRows[9].quantity)}`;
				retString += `&item_9_description=${encodeURIComponent((!this.tablesData.projectRows[9])? '' : this.tablesData.projectRows[9].item.description)}`;

				this.writeLog(retString);
				return retString;
			},
			async printLabel() {
				let ret = false;
				this.isPrinting = true;
				this.tablesData.projectRows = [];
				await this.searchProjectRows(this.projectId);
				if (this.tablesData.projectRows.length > 0) {
					await this.getPrinter(this.printerId)
					if (this.tablesData.currentPrinter.is_online == true) {
						this.tablesData.projectRows = [];
						ret = true;
						// remove empty packages
						for (let i = 0; i < this.tablesData.packages.length; i++) {
							await this.searchProjectRows(this.projectId, null, null, this.tablesData.packages[i].id);
							if (this.tablesData.projectRows.length <= 0) {
								await this.deletePackage(this.tablesData.packages[i].id, false);
							}
						}
						// print labels
						await this.searchPackages(this.projectId, false, false);
						for (let i = 0; i < this.tablesData.packages.length; i++) {
							await this.searchProjectRows(this.projectId, null, null, this.tablesData.packages[i].id);
							await this.executePrinterAction(`printers/` + this.printerId + this.preparePrinterData(i + 1, this.tablesData.packages[i].name)) //this.tablesData.packages[i].incremental
							.then(() => { /*ret = true;*/ })
							.catch(error => {
								this.checkUserSession(error, "warning");
								this.showMsgError(this.messageTitlePrint, this.errorPrintMessage);
								ret = false;
							})
						}
						if (ret == true && this.tablesData.packages.length > 0) {
							this.showMsgInfo(this.messageTitleInsert,this.successPrintMessage + "&nbsp" + this.tablesData.packages.length);
						}
					}
					else {
						this.showMsgWarning(
							this.messageTitlePrint,
							this.warningPrinterOffline);
					}
				}
				else {
					ret = true;
				}
				this.isPrinting = false;
				return ret;
			},
			async createEmptyProjectRows() {
				let myRecord = {
					project_rows: {
						project_id: this.projectId,
						pick_id: null,
						location_id: null,
						item_id: null,
						quantity: 0,
						package_id: null,
					}
				};
				for (let i = 0; i < this.tablesData.picks.length; i++) {
					if (this.tablesData.picks[i].quantity_detected == 0) {
						myRecord.project_rows.pick_id = this.tablesData.picks[i].id;
						myRecord.project_rows.location_id = this.tablesData.picks[i].location.id,
						myRecord.project_rows.item_id = this.tablesData.picks[i].item.id,
						await this.createProjectRow(myRecord, false)
					}
				}
			},
			getProjectStatus() {
				let status = {
					closed: true,
					untouched: true,
				};
				this.tablesData.picks.forEach(element => {
					if (parseFloat(element.quantity_detected) > 0) status.untouched = false;
					if (!this.allowExceededQuantity) {
						if (parseFloat(element.quantity) != parseFloat(element.quantity_detected)) status.closed = false;
					}
					else {
						if (parseFloat(element.quantity) > parseFloat(element.quantity_detected)) status.closed = false;
					}
				});
				return status;
			},
			async updateProjectFlags(storeFlag = null, preparedFlag = null, partialFlag = null, suspendedFlag = null) {
				let myRecord = {
					project: {
					}
				};
				if (storeFlag != null) myRecord.project['store'] = storeFlag
				if (preparedFlag != null) myRecord.project['prepared'] = preparedFlag
				if (partialFlag != null) myRecord.project['partial'] = partialFlag
				if (suspendedFlag != null) myRecord.project['suspended'] = suspendedFlag
				await this.updateProject(this.projectId, myRecord, false);
			},
			async closeOrder() {
				let canExit = true;
				let projectsStatus = this.getProjectStatus();

				if (projectsStatus.closed == true) {
					await this.updateProjectFlags(this.isPicking, this.isIncoming || this.isOutgoing, false, false);
				}
				else if (projectsStatus.untouched == true) {
					canExit = false;
				}
				else {
					await this.confirmYesNo(this.confirmExitTitle, this.confirmCloseMessage)
					.then((data) => { canExit = data })
					if (canExit == true) {
						await this.createEmptyProjectRows();
						await this.updateProjectFlags(this.isPicking, this.isIncoming || this.isOutgoing, true, false);
					}
				}
				if (canExit && this.canPrint) {
					// canExit = await this.printLabel();
					await this.printLabel();
				}

				if (canExit == true) {
					this.$router.push("/order/advanced/selection" + "?incoming=" + this.isIncoming + "&outgoing=" + this.isOutgoing + "&picking=" + this.isPicking);
				}
			},
			async exitOrder() {
				let canExit = true;
				let projectStatus = this.getProjectStatus();

				if (projectStatus.untouched == true) {
					await this.updateProjectFlags(null, null, null, false);
				}
				else {
					await this.confirmYesNo(this.confirmExitTitle, this.confirmExitMessage)
					.then((data) => { canExit = data })
					if (canExit == true) {
						await this.updateProjectFlags(null, null, false, true);
					}
				}

				if (canExit == true) {
					this.$router.push("/order/advanced/selection" + "?incoming=" + this.isIncoming + "&outgoing=" + this.isOutgoing + "&picking=" + this.isPicking);
				}
			}
		}
	});
</script>
